import Swiper from "swiper";
import { A11y, Mousewheel, Navigation, Scrollbar } from "swiper/modules";

function toggleGrabCursor(swiper: Swiper) {
  const shouldEnableGrab = !swiper.isLocked;
  swiper.params.grabCursor = shouldEnableGrab;
  swiper.el.style.cursor = shouldEnableGrab ? "grab" : "";
}

document.querySelectorAll("[data-carousel]").forEach(element => {
  const htmlElement = element as HTMLElement;
  const swiper = htmlElement.querySelector(".swiper") as HTMLElement | null;

  if (!swiper) {
    console.error("Swiper element not found");
    return;
  }

  new Swiper(swiper, {
    modules: [A11y, Mousewheel, Navigation, Scrollbar],
    a11y: {
      enabled: true,
      slideLabelMessage: htmlElement.dataset.slideAriaLabel,
      firstSlideMessage: htmlElement.dataset.navigationAriaLabelFirstSlide,
      lastSlideMessage: htmlElement.dataset.navigationAriaLabelLastSlide
    },
    direction: "horizontal",
    loop: false,
    slidesPerView: "auto",
    spaceBetween: 0,
    grabCursor: false,
    mousewheel: {
      sensitivity: 2,
      forceToAxis: true
    },
    navigation: {
      nextEl: element.querySelector(".swiper-next") as HTMLElement | null,
      prevEl: element.querySelector(".swiper-prev") as HTMLElement | null
    },
    scrollbar: {
      el: htmlElement.querySelector(".swiper-scrollbar") as HTMLElement | null,
      hide: false,
      snapOnRelease: true,
      draggable: true
    },
    touchEventsTarget: "container",
    on: {
      init(swiper) {
        toggleGrabCursor(swiper);
      },
      resize(swiper) {
        toggleGrabCursor(swiper);
      }
    }
  });
});
